
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 614 493"}},[_c('defs',[_c('path',{attrs:{"id":"shape-blob-pale-orange_svg__a","d":"M366.862 492.883c164.395-82.147 246.593-164.294 246.593-246.442C613.455 123.221 503.05 0 366.862 0S-156.46 272.911 69.125 353.233c150.39 53.547 249.637 100.098 297.737 139.65z"}})]),_c('use',{attrs:{"fill":"#E68272","fill-rule":"evenodd","transform":"matrix(-1 0 0 1 614 0)","xlink:href":"#shape-blob-pale-orange_svg__a"}})])
      }
    
      }
    